<template>
  <div class="support-banner">
    <p class="support-banner__text" v-html="bannerText"></p>
  </div>
</template>

<script>
import { DEFAULT_CLIENT_INFO } from '@/scripts/constants';
import { clientStoreTypes } from '@/store/types';
import { CONFIGURATIONS } from '@/scripts/constants/configurations';

export default {
  name: 'SupportBanner',
  computed: {
    bannerText() {
      return this.$t('onboarding_humana.banner', {
        PHONE_NUMBER: this.supportPhoneNumber,
      });
    },
    supportPhoneNumber() {
      return this.$store.getters[clientStoreTypes.getters.GET_CLIENT_CONFIGURATION](
        CONFIGURATIONS.SUPPORT_PHONE_NUMBER,
      ) || DEFAULT_CLIENT_INFO.PHONE_NUMBER;
    },
  },
};
</script>

<style lang="scss">
.support-banner {
  background-color: $secondary-color-dark;

  &__text {
    padding: 1.125rem 2.5rem;
    margin: 0;
    font-size: 1.125rem;
    line-height: $line-height-base;
    text-align: center;
    color: $white;

    > span {
      font-weight: 600;
    }
  }

}
</style>
